module.exports = __webpack_public_path__ + "img/Text.6d694886.png";